import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class Training extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'training'}
            title={ t('support.procedure.P9.title') }
            exportTitle={ t('support.procedure.P9.exportTitle') }
            exportFileName={'training.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Training);